import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { PosicaoDoCliente } from '@app/models/posicao-do-cliente.model';
import { PosicaoDoClienteService } from '@app/services/posicao-do-cliente.service';

@Component({
  selector: 'app-posicao-do-cliente-form',
  templateUrl: './posicao-do-cliente-form.component.html'
})
export class PosicaoDoClienteFormComponent implements OnInit {

  titulo: string;
  lstErros: string[];
  posicaoDoCliente: PosicaoDoCliente = new PosicaoDoCliente();
  aguardandoSolicitacao: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private posicaoDoClienteService: PosicaoDoClienteService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Posição do Cliente' : 'Nova Posição do Cliente';

      if (!id) {
        return;
      }

      this.posicaoDoClienteService.obterPorId(id).toPromise().then(
        data => this.posicaoDoCliente = data,
        () => this.router.navigate(['./configuracoes/posicao-do-cliente']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.posicaoDoClienteService.gravar(this.posicaoDoCliente).toPromise().then(
      () => this.router.navigate(['./configuracoes/posicao-do-cliente']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
